/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_Weighing_NoneInputs */

const vi_tea_lot_weighing_none = /** @type {(inputs: Tea_Lot_Weighing_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có phiếu cân`)
};

/**

* @param {Tea_Lot_Weighing_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_weighing_none = /** @type {((inputs?: Tea_Lot_Weighing_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_Weighing_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_weighing_none(inputs)
});